import React, { useState } from "react";
import { Card, Input, Button, Typography, message } from "antd";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_API_URL } from "../../../utils/consts";

const { Title, Text } = Typography;

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 80 }}>
        <Card>
          <Title level={4}>Invalid link</Title>
          <Text>Reset password link is missing or invalid.</Text>
        </Card>
      </div>
    );
  }

  const handleSubmit = async () => {
    if (!password) return message.warning("Please enter a new password");
    if (password.length < 6)
      return message.warning("Password must be at least 6 characters");

    try {
      setLoading(true);

      const payload = {
        token,
        password,
      };

      await axios.post(`${BASE_API_URL}/forgot-change-password`, payload);

      message.success("Password successfully reset");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err: any) {
      message.error(err?.response?.data?.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 400,
        margin: "80px auto",
        padding: 16,
      }}
    >
      <Card bordered>
        <Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
          Reset Password
        </Title>

        <Text strong>New password</Text>
        <Input.Password
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter new password"
          style={{ marginBottom: 20 }}
        />

        <Button
          type="primary"
          block
          size="large"
          loading={loading}
          onClick={handleSubmit}
        >
          Reset Password
        </Button>
      </Card>
    </div>
  );
};

export default ResetPassword;
